module.exports = __webpack_public_path__ + "img/8.73958bc6.jpg";